import React, { useState, useEffect } from 'react'
import cn from 'classnames'

interface CheckboxProps {
  label?: string
  containerClass?: string
  checked: boolean
  onClick: any
}

const RadioButton = ({ label, containerClass, checked, onClick }: CheckboxProps) => {
  const [isClient, setClient] = useState(false)
  useEffect(() => {
    setClient(true)
  }, [])

  const key = isClient ? 'client' : 'server'
  return (
    <button
      onClick={onClick}
      className={cn(containerClass, 'radio-button-container removeGenericButtonStyles')}
      key={key}
    >
      <label className='mb-0 d-flex justify-content-center align-items-center'>
        <div className='radio-button'>
          <span
            className={cn({
              'radio-button--checked': checked
            })}
          />
        </div>
        {label && <h6 className='checkboxAndRadioFont text-align-left'>{label}</h6>}
      </label>
    </button>
  )
}

export default RadioButton
